// extracted by mini-css-extract-plugin
module.exports = {"dialog":"dialog___21G_a","header":"header___6uVOT","content":"content___18tvB","dialogCover":"dialogCover___1ZuCL"};